// Angular + External
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// BFX
import { LoginComponent } from "./login.component";
import { LogoutComponent } from "./logout.component";
import { LoaderComponent } from "./loader.component";
import { RestartLogoutComponent } from "./restart-logout.component";
import { AuthGuard } from "../bfx-common/guards/auth-guard.service";
import { ResetGuard } from "../bfx-common/guards/reset-guard.service";
import { BfxChangePasswordComponent } from "./bfx-change-password.component";

const authRoutes: Routes = [
  { path: "login", component: LoginComponent },
  {
    path: "loading/:nextRoute",
    component: LoaderComponent,
    canActivate: [AuthGuard],
  },
  { path: "logout", component: LogoutComponent },
  { path: "restart-logout", component: RestartLogoutComponent },
  {
    path: "change-password",
    component: BfxChangePasswordComponent,
    canActivate: [ResetGuard],
  },
  { path: "", redirectTo: "login", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
